var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useMemo } from "react";
import useUniqueId from "../../hooks/useUniqueId";
import { StyledMainContainer } from "./MainContainer.style";
import { MainContainerContext } from "./MainContainerContext";
const idPrefix = "nx-main-container-";
const MainContainer = (_a) => {
    var { id } = _a, rest = __rest(_a, ["id"]);
    id = useUniqueId(idPrefix, id);
    const [hasBottomBar, setHasBottomBar] = useState(false);
    const [rightBarWidth, setRightBarWidth] = useState({
        value: 0,
        shouldAnimate: false,
    });
    const [variant, setVariant] = useState(undefined);
    const [mainContainerRef, setMainContainerRef] = useState();
    const value = useMemo(() => ({
        hasBottomBar,
        setHasBottomBar,
        rightBarWidth,
        setRightBarWidth,
        variant,
        setVariant,
        mainContainerRef,
    }), [hasBottomBar, rightBarWidth, variant, mainContainerRef]);
    return (React.createElement(MainContainerContext.Provider, { value: value },
        React.createElement(StyledMainContainer, Object.assign({ ref: setMainContainerRef, id: id }, rest))));
};
export default MainContainer;
//# sourceMappingURL=MainContainer.js.map